import './WebHeader.css';
import { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { setdevice } from '../../modules/actions/action';
import { ACTIVE_DEVICE, CONTAINER_CONST } from '../../common/constant/common-constants';
import { getTheme, setTheme, THEMES } from '../../utils/theme';
import { clearMachineDetailsSession } from '../../container/MachineDetails/machineDetailsSession';

const isMachineVersionDetailsPath = (pathname) => (
  /\/machine-details\/[^/]+/.test(pathname)
);

const WebHeader = (props) => {
  const { onMenuToggle, sidebarOpen = false } = props;
  const location = useLocation();
  const getInitialDevice = () => localStorage.getItem('selectedDevice') || ACTIVE_DEVICE.V730i;

  const [selectedDevice, setSelectedDevice] = useState(getInitialDevice);
  const [theme, setThemeState] = useState(getTheme);

  useEffect(() => {
    props.updateDevice(selectedDevice);
    localStorage.setItem('selectedDevice', selectedDevice);
  }, [selectedDevice, props]);

  const handleThemeToggle = () => {
    const nextTheme = theme === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK;
    setTheme(nextTheme);
    setThemeState(nextTheme);
  };

  const handleDeviceChange = (device) => {
    if (device === selectedDevice) return;
    clearMachineDetailsSession();
    setSelectedDevice(device);
  };

  const showDeviceToggle = (
    (props.activetab === CONTAINER_CONST.OTA_DETAILS_ACTIVE
      || props.activetab === CONTAINER_CONST.IP_LOG_UPLOAD_ACTIVE
      || props.activetab === CONTAINER_CONST.REQUEST_CALLBACK)
    && !isMachineVersionDetailsPath(location.pathname)
  );

  const displayName = useMemo(() => {
    const email = props.email?.trim();
    if (!email) return 'Noccarc Admin';
    const localPart = email.split('@')[0] || 'Admin';
    return localPart.charAt(0).toUpperCase() + localPart.slice(1);
  }, [props.email]);

  const userInitial = displayName.charAt(0).toUpperCase();

  return (
    <header className="app-topbar">
      <div className="app-topbar-left">
        <button
          type="button"
          className="app-topbar-icon-btn app-topbar-menu-btn"
          aria-label={sidebarOpen ? 'Close navigation menu' : 'Open navigation menu'}
          aria-expanded={sidebarOpen}
          onClick={() => onMenuToggle?.()}
        >
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 7h16M4 12h16M4 17h16" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
        <div className="app-topbar-brand">
          <div className="app-topbar-brand-text">
            <strong>Noccarc</strong>
            <span>Admin Dashboard</span>
          </div>
        </div>
      </div>

      <div className="app-topbar-right">
        {showDeviceToggle && (
          <div className="app-topbar-device-toggle">
            <button
              type="button"
              className={`app-topbar-device-btn${selectedDevice === ACTIVE_DEVICE.V730i ? ' app-topbar-device-btn--active' : ''}`}
              onClick={() => handleDeviceChange(ACTIVE_DEVICE.V730i)}
            >
              V730i
            </button>
            <button
              type="button"
              className={`app-topbar-device-btn${selectedDevice === ACTIVE_DEVICE.NX5 ? ' app-topbar-device-btn--active' : ''}`}
              onClick={() => handleDeviceChange(ACTIVE_DEVICE.NX5)}
            >
              NX5
            </button>
          </div>
        )}

        <button
          type="button"
          className="app-topbar-icon-btn app-topbar-theme-btn"
          aria-label={theme === THEMES.DARK ? 'Switch to light theme' : 'Switch to dark theme'}
          title={theme === THEMES.DARK ? 'Light mode' : 'Dark mode'}
          onClick={handleThemeToggle}
        >
          {theme === THEMES.DARK ? (
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <circle cx="12" cy="12" r="4.5" fill="none" stroke="currentColor" strokeWidth="1.8" />
              <path d="M12 2.5v2.2M12 19.3v2.2M4.7 4.7l1.6 1.6M17.7 17.7l1.6 1.6M2.5 12h2.2M19.3 12h2.2M4.7 19.3l1.6-1.6M17.7 6.3l1.6-1.6" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
            </svg>
          ) : (
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M21 14.5A8.5 8.5 0 0 1 9.5 3a7 7 0 1 0 11.5 11.5Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            </svg>
          )}
        </button>

        <button type="button" className="app-topbar-icon-btn" aria-label="Notifications">
          <svg viewBox="0 0 24 24" aria-hidden="true">
            <path d="M12 4a4 4 0 0 0-4 4v2.5c0 .8-.3 1.6-.8 2.2L5.5 15.5h13l-1.7-2.8c-.5-.6-.8-1.4-.8-2.2V8a4 4 0 0 0-4-4Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
            <path d="M10 18a2 2 0 0 0 4 0" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
          {props.hasNotification && <span className="app-topbar-notification-dot" />}
        </button>

        <button type="button" className="app-topbar-profile" aria-label="User menu">
          <span className="app-topbar-avatar">{userInitial}</span>
          <span className="app-topbar-profile-name">{displayName}</span>
          <svg className="app-topbar-chevron" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M8 10l4 4 4-4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
          </svg>
        </button>
      </div>
    </header>
  );
};

const mapStateToProps = (state) => ({
  activetab: state.activeIcon.activeSideBarIcon,
  email: state.userDetails?.email,
  hasNotification: state.showNotification?.showNotificatin,
});

const mapDispatchToProps = (dispatch) => ({
  updateDevice: (device) => dispatch(setdevice(device)),
});

export default connect(mapStateToProps, mapDispatchToProps)(WebHeader);
